var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.709 4.70714C17.0995 4.31663 17.0995 3.68346 16.709 3.29292C16.3185 2.90238 15.6854 2.90236 15.2948 3.29286L10.0009 8.58627L4.70708 3.29286C4.31654 2.90236 3.68338 2.90238 3.29287 3.29292C2.90236 3.68346 2.90239 4.31663 3.29293 4.70714L8.58667 10.0004L3.29292 15.2937C2.90238 15.6842 2.90236 16.3174 3.29286 16.7079C3.68337 17.0985 4.31654 17.0985 4.70708 16.708L10.0009 11.4146L15.2948 16.708C15.6854 17.0985 16.3185 17.0985 16.709 16.7079C17.0995 16.3174 17.0995 15.6842 16.709 15.2937L11.4152 10.0004L16.709 4.70714Z",
    fill: "#888891"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-Close.524fc5be1a38339340bc80510fe920b4.svg";
export { ForwardRef as ReactComponent };